"use strict";

/**
 * Module EMAIL SERVICES
 */
angular.module("services")
	.factory("LogsService", ["$http", "SharedProperties", "ENV", function ($http, SharedProperties, ENV) {

		const RESOURCE_NAME = "/platform-logs";

		// JAVA ENUM PlatformLogAction
		const SUBSCRIBER_ADD = "SUBSCRIBER_ADD";
		const SUBSCRIBER_UPDATE = "SUBSCRIBER_UPDATE";
		const SUBSCRIBER_CHANGE_DROP_IN_CENTER = "SUBSCRIBER_CHANGE_DROP_IN_CENTER";
		const SUBSCRIBER_TRANSFER_LEGAL_REPRESENTATIVE = "SUBSCRIBER_TRANSFER_LEGAL_REPRESENTATIVE";
		const SUBSCRIBER_UPDATE_SUBSCRIPTION_STATUS = "SUBSCRIBER_UPDATE_SUBSCRIPTION_STATUS";
		const SUBSCRIBER_ADD_TRANSPORT_TICKET = "SUBSCRIBER_ADD_TRANSPORT_TICKET";
		const SUBSCRIBER_DISABLE_TRANSPORT_TICKET = "SUBSCRIBER_DISABLE_TRANSPORT_TICKET";
		const SUBSCRIBER_END_SUBSCRIPTION = "SUBSCRIBER_END_SUBSCRIPTION";
		const SUBSCRIBER_TITRE_RELAIS_NOTIFICATION = "SUBSCRIBER_TITRE_RELAIS_NOTIFICATION";
		const SUBSCRIBER_ADD_ATTACHED_FILE = "SUBSCRIBER_ADD_ATTACHED_FILE";
		const SUBSCRIBER_RECEIVE_ATTACHED_FILE = "SUBSCRIBER_RECEIVE_ATTACHED_FILE";
		const SUBSCRIBER_UNRECEIVE_ATTACHED_FILE = "SUBSCRIBER_UNRECEIVE_ATTACHED_FILE";
		const SUBSCRIBER_DELETE_ATTACHED_FILE = "SUBSCRIBER_DELETE_ATTACHED_FILE";
		const SUBSCRIBER_ADD_SUBSCRIPTION = "SUBSCRIBER_ADD_SUBSCRIPTION";
		const SUBSCRIBER_ADD_TRIPS = "SUBSCRIBER_ADD_TRIPS";
		const SUBSCRIBER_DISABLE_TRIPS = "SUBSCRIBER_DISABLE_TRIPS";
		const SUBSCRIBER_DISABLE_SUBSCRIPTION = "SUBSCRIBER_DISABLE_SUBSCRIPTION";

		return {
			search: search,

			logActionSubscriber: [
				SUBSCRIBER_ADD, SUBSCRIBER_UPDATE, SUBSCRIBER_CHANGE_DROP_IN_CENTER, SUBSCRIBER_TRANSFER_LEGAL_REPRESENTATIVE,
				SUBSCRIBER_UPDATE_SUBSCRIPTION_STATUS, SUBSCRIBER_END_SUBSCRIPTION, SUBSCRIBER_TITRE_RELAIS_NOTIFICATION,
				SUBSCRIBER_ADD_ATTACHED_FILE, SUBSCRIBER_RECEIVE_ATTACHED_FILE, SUBSCRIBER_UNRECEIVE_ATTACHED_FILE, SUBSCRIBER_DELETE_ATTACHED_FILE,
				SUBSCRIBER_ADD_SUBSCRIPTION, SUBSCRIBER_DISABLE_SUBSCRIPTION, SUBSCRIBER_ADD_TRANSPORT_TICKET, SUBSCRIBER_DISABLE_TRANSPORT_TICKET,
				SUBSCRIBER_ADD_TRIPS, SUBSCRIBER_DISABLE_TRIPS
			]
		};

		function search(searchElements) {
			return $http.post(ENV.API_URL + RESOURCE_NAME + "/search", searchElements);
		}

	}

	])
;


